/**
 * G09: Geo-Anchor State
 * In-memory state management for geo-anchor (linking real-world to editor coordinates)
 */

import type { GeoAnchor } from './types'

let currentGeoAnchor: GeoAnchor | null = null

/**
 * Set the current geo-anchor
 */
export function setGeoAnchor(anchor: GeoAnchor): void {
  currentGeoAnchor = anchor
}

/**
 * Get the current geo-anchor
 */
export function getGeoAnchor(): GeoAnchor | null {
  return currentGeoAnchor
}

/**
 * Clear the current geo-anchor
 */
export function clearGeoAnchor(): void {
  currentGeoAnchor = null
}

/**
 * Check if a geo-anchor is set
 */
export function hasGeoAnchor(): boolean {
  return currentGeoAnchor !== null
}
